import { Language } from '../../../common/languages.js';
import { IRsvpForm, RsvpFormClass } from './form/lang.js';

export interface IRsvpAdditionalQuestionsLang {
  header: string;
  querry: string;
  default: string;
  info: string;
  placeholder: string;
  optionTrue: string;
  optionFalse: string;
  selectOptions: string[];
}

export interface IRsvpPlacesLang {
  name: string;
  location: string;
}

export interface IRsvpWishesLang {
  text: string;
}

export interface IRsvpLang {
  clientId: string;
  place: string;
  additionalInformation: string;
  additionalSecondInformation: string;
  places: Array<IRsvpPlacesLang>;
  additionalQuestions: Array<IRsvpAdditionalQuestionsLang>;
  wishes: Array<IRsvpWishesLang>;
  invitationPurposeText: string;
  invitationText: string;
  formattedDueToText: string;
  upperHeaderText: string;
  yearText: string;
  bottomText: string;
  bottomYearText: string;
  moreInfoText: string;
  form: IRsvpForm;

  getValue<T>(key: string): T;
}

export type IRsvpLangState = {
  [lang in Language]: IRsvpLang;
};

export class RsvpLangClass implements IRsvpLang {
  clientId: string;
  place: string;
  additionalInformation: string;
  additionalSecondInformation: string;
  places: Array<IRsvpPlacesLang>;
  additionalQuestions: Array<IRsvpAdditionalQuestionsLang>;
  wishes: Array<IRsvpWishesLang>;
  invitationPurposeText: string;
  invitationText: string;
  formattedDueToText: string;
  upperHeaderText: string;
  yearText: string;
  bottomText: string;
  bottomYearText: string;
  moreInfoText: string;
  form: IRsvpForm;

  constructor(rsvp?: Partial<IRsvpLang>) {
    this.clientId = rsvp?.clientId ?? '';
    this.place = rsvp?.place ?? ''; // TODO refactor this element -> move to places
    this.additionalInformation = rsvp?.additionalInformation ?? '';
    this.additionalSecondInformation = rsvp?.additionalSecondInformation ?? '';
    this.places = rsvp?.places ?? [];
    this.additionalQuestions = rsvp?.additionalQuestions ?? [];
    this.wishes = rsvp?.wishes ?? [];
    this.invitationPurposeText = rsvp?.invitationPurposeText ?? '';
    this.invitationText = rsvp?.invitationText ?? '';
    this.formattedDueToText = rsvp?.formattedDueToText ?? '';
    this.upperHeaderText = rsvp?.upperHeaderText ?? '';
    this.yearText = rsvp?.yearText ?? '';
    this.bottomText = rsvp?.bottomText ?? '';
    this.bottomYearText = rsvp?.bottomYearText ?? '';
    this.moreInfoText = rsvp?.moreInfoText ?? '';
    this.form = rsvp?.form ?? new RsvpFormClass();
  }

  getValue<T>(key: string): T {
    return this[key] as T;
  }
}
